import { baseApi } from '../apiProvider';
import {
  RequestGetGiftHistory,
  RequestGetGiveTypes,
  RequestSendGift,
} from '../models/request/requestGift';
import {
  ResponseGift,
  ResponseGiftBonus,
  ResponseGiftCategory,
  ResponseGiftMission,
  ResponseSendGift,
} from '../models/response/responseGift';

const giftAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // get gift categories
    getGiftCategories: builder.query<ResponseGiftCategory[], void>({
      query: () => ({
        url: '/v0/gift-categories',
        method: 'GET',
      }),
    }),
    // get gift types mutation
    getGiftTypes: builder.mutation<ResponseGift[], RequestGetGiveTypes>({
      query: (params: RequestGetGiveTypes) => ({
        url: '/v0/gift-type',
        method: 'GET',
        params,
      }),
    }),
    // get gift types query
    getGiftTypesMission: builder.query<ResponseGiftMission[], void>({
      query: () => ({
        url: '/v0/gift-type/mission',
        method: 'GET',
      }),
    }),
    // get bonus gift types query
    getGiftTypesBonus: builder.query<ResponseGiftBonus[], void>({
      query: () => ({
        url: '/v0/gift-type/bonus',
        method: 'GET',
      }),
      providesTags: ['GiftBonus'],
    }),
    // get history gift types query
    getGiftTypesHistory: builder.mutation<
      ResponseGift[],
      RequestGetGiftHistory
    >({
      query: (params: RequestGetGiveTypes) => ({
        url: '/v0/gift-type/history',
        method: 'GET',
        params,
      }),
    }),
    // send gift
    sendGift: builder.mutation<ResponseSendGift, RequestSendGift>({
      query: (body: RequestSendGift) => ({
        url: '/v0/gift',
        method: 'POST',
        body,
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetGiftCategoriesQuery,
  useGetGiftTypesMutation,
  useGetGiftTypesMissionQuery,
  useSendGiftMutation,
  useGetGiftTypesBonusQuery,
  useGetGiftTypesHistoryMutation,
} = giftAPI;
